import type { ReactNode } from 'react'

type AssistantPanelProps = {
  open: boolean
  onClose: () => void
  // Body content (the focused-item detail and / or the suggestions list).
  // The body is responsible for its own internal headers and close affordances
  // — the assistant scaffold itself is just a sized container with a thin
  // top bar (so the user can always close the whole panel with one X).
  body: ReactNode
  // When `body` already renders its own header (e.g. PairDetailColumn), set
  // `chromeless` to skip the assistant's own header. The user's "close
  // assistant" affordance then comes from the toolbar toggle.
  chromeless?: boolean
}

/**
 * Right-side assistant column. User-toggled (open / close), persists across
 * selections.
 */
export function AssistantPanel({ open, onClose, body, chromeless = false }: AssistantPanelProps) {
  if (!open) return null
  return (
    <div className="w-[360px] shrink-0">
      <div className="flex flex-col h-full overflow-hidden bg-white rounded-xl shadow-sm">
        {!chromeless && (
          <div className="flex items-center justify-between gap-2 px-3 py-2 shrink-0 border-b border-gray-100">
            <span className="text-xs font-semibold uppercase tracking-wider text-gray-500">
              Assistant
            </span>
            <button
              onClick={onClose}
              className="w-7 h-7 flex items-center justify-center rounded-md text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors"
              title="Close assistant"
            >
              ✕
            </button>
          </div>
        )}
        <div className="flex-1 overflow-y-auto">{body}</div>
      </div>
    </div>
  )
}
